const state = {
    data: {}
}

const getters = {
    getDataConnectLine() {
        return state.data;
    }
}

const mutations = {
    async setDataConnectLine(data) {
        let dataEvent = data.split('||');

        state.data = {
            queue: dataEvent[0],
            name: dataEvent[1],
            phone: dataEvent[1],
            protocol: dataEvent[2],
            type: 'phone'
        }
        return state.data;
    },

    async delDataConnectLine() {
        state.data = {}
    },

    async setChatData(data) {
        if (data) {
            state.data = {
                protocol: data.protocol,
                phone: data.phone,
                type: data.channel || "chat",
                name: data.name,
                queue: data.queue,
                id_crm: data.id_crm,
                instagram_id: data?.instagram_id,
                sessionDate: data.sessionDate || null,
                cpf_cnpj: data?.cpf_cnpj ?? "",
                email_cliente: data?.email_cliente ?? "",
                empresa: data?.empresa ?? "",
                dat_emissao: data?.dat_emissao ?? "",
                num_pedido: data?.num_pedido ?? "",
                cpd: data?.cpd ?? "",
            };
        }

        return state.data;
    },

}

export default {
    state,
    getters,
    mutations
}
